<div class="course-form">
  <header class="cf-head">
    <span class="cf-head__icon"><i class="fas fa-users" aria-hidden="true"></i></span>
    <div class="cf-head__text">
      <h1 class="cf-head__title">Batches</h1>
      <p class="cf-head__sub">{{moduleInfo.name}}</p>
    </div>
  </header>

  <section class="cf-card">
    <div class="table-responsive">
      <table class="table align-items-center table-flush table-hover">
        <thead class="thead-light">
          <tr>
            <th>Name</th>
            <th>Start Date</th>
            <th>End Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of moduleBatches" class="handCusor" (click)="navigateToDetails(item.id)">
            <td>{{item.name}}</td>
            <td>{{this.util.formatDate(item.startDate)}}</td>
            <td>{{this.util.formatDate(item.endDate)}}</td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="moduleBatches.length<=0" class="cf-empty">No batches yet</p>
    </div>
  </section>
</div>
